import React from 'react';

import InfoScreenTabs from './InfoScreenTabs';

const InfoScreen = () => {
  return (
    <section className="info-screen" id="info-screen-container-id">
      <div className="tutorium-container">
        <p className="landing-caption-dark">
          Tutorium is a comprehensive educational platform that helps you improve your skills and productivity
        </p>
        <div className="info-screen-body pb-100px">
          <InfoScreenTabs.Container>
            <InfoScreenTabs.Tab id="depth" title="In-depth knowledge" icon="img/icons/landing-about-tab-1.svg">
              <InfoScreenTabs.Content
                imgPath="/img/info-screen-tab-1.jpg"
                title="In-depth detailed courses"
                paragraph1="All courses and programs are created by professional developers with a great experience. You will
                    receive a professional mentor who will guide and help you during all education process. The mentor
                    also will analyze your tasks and supervise you thoughout the course."
                paragraph2="Personal practical tasks created by the mentor will help you to deep dive into the course topic and
                    get the maximum profit of education. Knowledge that you will get from education, will improve your
                    skills and make you more effective and faster as a developer."
              />
            </InfoScreenTabs.Tab>
            <InfoScreenTabs.Tab id="fundamental" title="Fundamental concepts" icon="img/icons/landing-about-tab-2.svg">
              <InfoScreenTabs.Content
                imgPath="/img/info-screen-tab-2.jpg"
                title="Fundamental concepts"
                paragraph1="We pay a lot of attention to fundamental knowledge. As our practice shows, many developers do not
                    know the basics very well. We help them to fill their gaps. A better understanding of the basis
                    helps to improve their professional skills and become a better employee."
                paragraph2=" We have a unique test system to check the knowledge of developers of any professional level. It
                    gives us an opportunity to create personalized educational programs based on each developer's
                    skills. It allows to reach maximal progress in education in a short period of time."
              />
            </InfoScreenTabs.Tab>
            <InfoScreenTabs.Tab id="uniq" title="Uniq programs" icon="img/icons/landing-about-tab-3.svg">
              <InfoScreenTabs.Content
                imgPath="/img/info-screen-tab-3.jpg"
                title="Uniq personal programs"
                paragraph1="We have a lot of separate small courses divided info a lot of categories. We call them building
                    blocks of our educational programs. They give us flexibility in creating programs. It allows us to
                    create unique programs for each developer combining courses."
                paragraph2="A unique system was developed to check the knowledge on any stage of education in order to check how
                    the selected program works. We can change the program on-the-fly if it is necessary. It gives us the
                    possibility to teach faster without losing quality."
              />
            </InfoScreenTabs.Tab>
          </InfoScreenTabs.Container>
        </div>
      </div>
    </section>
  );
};

export default InfoScreen;
